import { FieldReviewTable } from '../fieldReviewTable';

export interface HudReviewTableProps {
  data: Record<string, any>;
}

export const HudReviewTable = ({ data }: HudReviewTableProps) => {
  return <FieldReviewTable items={data?.items} />;
};
